import React from 'react';

export const Gallery = React.lazy(() => import('./Gallery'));
